import {
    Grid, Card, CardContent, CardHeader, List, ListItem, ListItemAvatar, Avatar, ListItemText, Typography,
    Breadcrumbs,
    Link,
    Snackbar
} from '@mui/material'
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';
import AddHomeWorkTwoToneIcon from '@mui/icons-material/AddHomeWorkTwoTone';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';

export default function Videos() {

    return (
        <>
            <Grid container direction='row' justifyContent='center' style={{ marginTop: 50 }} gap={3}>
                <Grid item xs={12} md={6}>
                    <Card>
                        <CardHeader title='MENÚS'></CardHeader>
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <div style={{ position: 'relative', paddingTop: '56.25%' /* 16:9 ratio */, width: '100%' }}>
                                        <iframe
                                            src="https://www.youtube.com/embed/Akr0n5TQmSY?si=Qjx6IV2U-V5qV4Mm"
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            allowFullScreen
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                border: 0
                                            }}
                                        ></iframe>
                                    </div>
                                </Grid>
                            </Grid>

                        </CardContent>
                    </Card>

                </Grid>
                <Grid item xs={12} md={6}>
                    <Card>
                        <CardHeader title='GESTIÓN DE SERVICIOS'></CardHeader>
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <div style={{ position: 'relative', paddingTop: '56.25%' /* 16:9 ratio */, width: '100%' }}>
                                        <iframe
                                            src="https://www.youtube.com/embed/DZ3KbwDwr5A?si=eBJ4v9G4IrkBMdxN"
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            allowFullScreen
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                border: 0
                                            }}
                                        ></iframe>
                                    </div>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                </Grid>
                <Grid item xs={12} md={6}>
                    <Card>
                        <CardHeader title='HERRAMIENTAS ADMINISTRATIVAS'></CardHeader>
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <div style={{ position: 'relative', paddingTop: '56.25%' /* 16:9 ratio */, width: '100%' }}>
                                        <iframe
                                            src="https://www.youtube.com/embed/geSx9SNRG5I?si=sAj2GzB5kB_K2DXp"
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            allowFullScreen
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                border: 0
                                            }}
                                        ></iframe>
                                    </div>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </>
    )
}